const decToHex = (dec: string): string => {
	return Number(dec).toString(16).toUpperCase();
};

const padToTwo = (str: string): string => {
	return str.padStart(2, '0');
};

const rgbToHex = (r: string, g: string, b: string): string => {
	const hexR = padToTwo(decToHex(r));
	const hexG = padToTwo(decToHex(g));
	const hexB = padToTwo(decToHex(b));

	return `#${hexR}${hexG}${hexB}`;
};

const rgbRegex = /rgb\((?<red>\d+), ?(?<green>\d+), ?(?<blue>\d+)\)/i;

export const maybeConvertToHex = (color: string): string => {
	const rgbMatch = color.match(rgbRegex);
	if (rgbMatch) {
		const red = rgbMatch.groups?.red ?? '';
		const green = rgbMatch.groups?.green ?? '';
		const blue = rgbMatch.groups?.blue ?? '';
		return rgbToHex(red, green, blue);
	}

	return color;
};
